import React from 'react';

const BASE = {
  wrap: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    position: 'absolute',
    left: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    display: 'flex',
    color: '#94a3b8',
  },
  // Design System: borde 1px #E2E8F0, radio 8px, sin sombra en reposo.
  input: {
    width: '100%',
    padding: '6px 10px 6px 32px',
    border: '1px solid #E2E8F0',
    borderRadius: 8,
    fontSize: 13,
    outline: 'none',
    boxSizing: 'border-box',
    background: '#fff',
    boxShadow: 'none',
    color: '#1E293B',
    fontFamily: 'inherit',
    transition: 'border-color 0.15s, box-shadow 0.15s',
  },
  select: {
    height: 32,
    padding: '0 10px',
    border: '1px solid #E2E8F0',
    borderRadius: 8,
    fontSize: 13,
    background: '#fff',
    color: '#1E293B',
    outline: 'none',
    cursor: 'pointer',
    boxShadow: 'none',
    fontFamily: 'inherit',
    transition: 'border-color 0.15s',
    maxWidth: '100%',
  },
  clearBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '7px 12px',
    border: '1px solid #FECACA',
    borderRadius: 8,
    background: '#FEE2E2',
    color: '#991B1B',
    fontSize: 12,
    cursor: 'pointer',
    fontWeight: 700,
    fontFamily: 'inherit',
    whiteSpace: 'nowrap',
  },
};

// Foco: borde amarillo + halo 2px al 20% (regla de inputs del design system).
function onFocus(e)  { e.target.style.borderColor = '#FFB800'; e.target.style.boxShadow = '0 0 0 2px rgba(255,184,0,0.20)'; }
function onBlur(e)   { e.target.style.borderColor = '#E2E8F0'; e.target.style.boxShadow = 'none'; }
function onFocusSel(e) { e.target.style.borderColor = '#FFB800'; e.target.style.boxShadow = '0 0 0 2px rgba(255,184,0,0.20)'; }
function onBlurSel(e)  { e.target.style.borderColor = '#E2E8F0'; e.target.style.boxShadow = 'none'; }

export function SearchInput({ value, onChange, placeholder, style, inputRef }) {
  return (
    <div style={{ ...BASE.wrap, ...style }}>
      <span style={BASE.icon}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
      </span>
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder ?? 'Buscar...'}
        value={value}
        onChange={onChange}
        style={BASE.input}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
}

export function FilterSelect({ value, onChange, children, style }) {
  return (
    <select
      value={value}
      onChange={onChange}
      style={{ ...BASE.select, ...style }}
      onFocus={onFocusSel}
      onBlur={onBlurSel}
    >
      {children}
    </select>
  );
}

export function ClearFiltersBtn({ onClick, children }) {
  return (
    <button type="button" onClick={onClick} style={BASE.clearBtn}>
      {children ?? 'Limpiar filtros'}
    </button>
  );
}
